import config from "@/appConfig"
import axios from "axios"

const state = { status: "", token: "", user: { role: [] } }
const actions = {
  login: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit("login")
      axios({
        url: config.BASE_API_URL + "/api/authenticate",
        data: user,
        method: "POST",
      })
        .then((resp) => {
          const data = resp.data
          commit("success", data)
          resolve(resp)
        })
        .catch((err) => {
          commit("error", err)
          reject(err)
        })
    })
  },
  loginPMSE: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit("login")
      axios({
        url: config.BASE_API_URL + "/api/auth/login",
        data: user,
        method: "POST",
      })
        .then((resp) => {
          const data = resp.data
          commit("success", data)
          resolve(resp)
        })
        .catch((err) => {
          commit("error", err)
          reject(err)
        })
    })
  },
  loginSso: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit("login")
      axios({
        url: config.BASE_API_URL + "/api/authenticate/sso",
        data: data,
        method: "POST",
      })
        .then((resp) => {
          const data = resp.data
          commit("success", data)
          resolve(resp)
        })
        .catch((err) => {
          commit("error", err)
          reject(err)
        })
    })
  },
  logout: ({ commit }) => {
    return new Promise((resolve) => {
      commit("logout")
      delete axios.defaults.headers.common["Authorization"]
      resolve()
    })
  },
  setIsApproved: ({ commit }, isApproved) => {
    return new Promise((resolve) => {
      commit("setIsApproved", isApproved)
      resolve(isApproved)
    })
  },
}
const mutations = {
  setIsApproved: (state, isApproved) => {
    state.user.isApproved = isApproved
  },
  login: (state) => {
    state.status = "loading"
  },
  success: (state, data) => {
    state.status = 1
    state.token = data.token
    state.user.role = data.role
    state.user.id = data.id == null ? data.userInfo.id : data.id
    state.user.name = data.userInfo.name
    state.user.email = data.userInfo.email
    state.user.username = data.userInfo.username
    state.user.photoUrl =
      data.userInfo.photoUrl == null
        ? "/img/error/user.svg"
        : data.userInfo.photoUrl
    state.user.organisasi =
      data.userInfo.organisasi == null
        ? data.userInfo.instansi
        : "Badan Pusat Statistik"
    state.user.idOrganisasi =
      data.userInfo.instansiID != null
        ? data.userInfo.instansiID
        : data.instansiID
    state.user.idProvinsi =
      data.userInfo.idProvinsi != null
        ? data.userInfo.idProvinsi
        : data.idProvinsi
    state.user.provinsi =
      data.userInfo.provinsi != null
        ? data.userInfo.provinsi
        : data.provinsi
    state.user.idKabupatenKota =
      data.userInfo.idKabupatenKota != null
        ? data.userInfo.idKabupatenKota
        : data.idKabupatenKota
    state.user.kabupatenKota =
      data.userInfo.kabupatenKota != null
        ? data.userInfo.kabupatenKota
        : data.kabupatenKota
    state.user.kdorganisasi =
      data.userInfo.organisasi != null ? data.userInfo.organisasi : null
    state.user.eselon =
      data.userInfo.eselon != null ? data.userInfo.eselon : null
    state.user.slugOrganisasi =
      data.userInfo.slugInstansi == null
        ? "dd3fc0aa-4579-4dd2-b10e-003a679c1e78"
        : data.userInfo.slugInstansi

    state.user.unitKerja =
      data.userInfo.unitKerja != null
        ? data.userInfo.unitKerja
        : data.unitKerja
    state.user.walidata =
      data.userInfo.walidata != null
        ? data.userInfo.walidata
        : data.walidata
    state.user.sdiOrganization = data.sdiOrganization
    state.user.isApproved = data.userInfo.isApproved
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + state.token
  },
  logout: (state) => {
    state.status = 0
    state.token = ""
    state.user = {}
    axios.defaults.headers.common["Authorization"] = ""
  },
  error: (state, data) => {
    state.status = 0
    state.error = data
  },
  coba: (state, value) => {
    state.coba = value
  },
}
const getters = {
  isAuthenticated: (state) =>
    !!state.token &&
    !(
      Date.now() >=
      JSON.parse(window.atob(state.token.split(".")[1])).exp * 1000
    ),
  isError: (state) => !state.status,
  error: (state) => state.error,
  authStatus: (state) => state.status,
  user: (state) => state.user,
  token: (state) => state.token,
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
